import React from 'react';

const CustomTextArea = ({...props}) => {
  return (
    <textarea
      className="text-sm text-gray-6 text-[16px] border rounded-2xl  bg-gray-1 resize-none focus:outline-none p-4"
      {...props}
    />
  );
};

export default CustomTextArea;
